<template>
  <div class="app-container">
    <div class="type-list-filter">
      <el-row>
        <el-col :span="6">
          <el-input class="type-list-filter-value" size="small" placeholder="分类名称" suffix-icon="el-icon-search" clearable v-model.trim="search.name" @keyup.enter.native="getList"></el-input>
        </el-col>
        <el-col :span="18">
          <el-button class="type-list-filter-reset" size="small" @click="getList">立即筛选</el-button>
          <el-button class="type-list-filter-search" size="small" @click="searchReset">清除条件</el-button>
        </el-col>
      </el-row>
    </div>

    <basic-container>
      <avue-crud 
        ref="crud"
        :option="tableOption"
        :data="tableData"
        :page="page"
        :table-loading="tableLoading"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        @sort-change="handleSortChange">

        <template slot="isActive" slot-scope="scope" >
          <span>{{ scope.row.isActive ? '是' : '否' }}</span>
        </template>

        <template slot="menuLeft">
          <el-button v-if="permissions.goods_type_add" type="primary" icon="el-icon-plus" size="small" @click="openAddDialog">新增分类</el-button>
          <el-button v-if="permissions.goods_type_cache_sync" type="primary" icon="el-icon-refresh" @click="handleSyncCache" size="small">同步</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button v-if="permissions.goods_type_edit" type="text" icon="el-icon-edit" size="mini" @click="openEditDialog(scope.row)">编辑</el-button>
          <el-button v-if="permissions.goods_type_del" type="text" icon="el-icon-delete" size="mini" @click="handleDelete(scope.row)">删除</el-button>
        </template>

      </avue-crud>
    </basic-container>

    <el-dialog
      title="添加分类"
      :visible.sync="addGoodsTypeDialog"
      @close="closeAddDialog"
      :close-on-click-modal="false"
      width="30%"
      class="handle-dialog">
        <el-form ref="addGoodsTypeFrom" :model="addGoodsTypeFrom" :rules="rules">
            <el-form-item prop="name">
              <el-label >分类名称:</el-label>
              <el-input type="text" placeholder="请输入分类名称" v-model="addGoodsTypeFrom.name" clearable></el-input>
            </el-form-item>
            <el-form-item prop="isActive">
              <el-label >是否在商城中显示:</el-label>
              <el-select placeholder="是否在商城中显示" v-model="addGoodsTypeFrom.isActive" clearable size="small">
                <el-option
                  v-for="item in goodsTypeActiveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <div class="handle-dialog-footer">
              <el-button class="handle-dialog-footer-cancel" @click="closeAddDialog">取消</el-button>
              <el-button type="primary" class="handle-dialog-footer-save" @click="handleAdd">确定</el-button>
            </div>
        </el-form>
    </el-dialog>
    <el-dialog
      title="编辑分类"
      :visible.sync="editGoodsTypeDialog"
      @close="closeEditDialog"
      :close-on-click-modal="false"
      width="30%"
      class="handle-dialog">
        <el-form ref="editGoodsTypeFrom" :model="editGoodsTypeFrom" :rules="rules">
            <el-form-item prop="name">
              <el-label >分类名称:</el-label>
              <el-input type="text" placeholder="请输入分类名称" v-model="editGoodsTypeFrom.name" clearable></el-input>
            </el-form-item>
            <el-form-item prop="isActive">
              <el-label >是否在商城中显示:</el-label>
              <el-select placeholder="是否在商城中显示" v-model="editGoodsTypeFrom.isActive" clearable size="small">
                <el-option
                  v-for="item in goodsTypeActiveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <div class="handle-dialog-footer">
              <el-button class="handle-dialog-footer-cancel" @click="closeEditDialog">取消</el-button>
              <el-button type="primary" class="handle-dialog-footer-save" @click="handleEdit">确定</el-button>
            </div>
        </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { goodsTypesTableOption } from '@/const/crud/mall/type';
import { fetchGoodsTypePage, addGoodsType, editGoodsTypeById, removeGoodsTypeById, syncGoodsTypeCache } from '@/api/mall/type';
import { mapGetters } from "vuex";

export default {
  data () {
    return {
      tableOption: goodsTypesTableOption,
      addGoodsTypeDialog: false,
      editGoodsTypeDialog: false,
      tableData: [],
      addGoodsTypeFrom: {
        name: '',
        isActive: null
      },
      editGoodsTypeFrom: {
        id: undefined,
        name: '',
        isActive: null
      },
      rules: {
        name: [
          { required: true, message: '分类名称不能为空', trigger: 'blur' },
          { max: 20, message: '长度不超过 20 个字符', trigger: 'blur' }
        ],
        isActive: [
          { required: true, message: '请选择是否在商城中显示', trigger: 'change' }
        ]
      },
      tableLoading: false,
      search: {
        current: 1,
        size: 10,
        sortField: '',
        sortPolicy: '',
        name: '',
      },
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      goodsTypeActiveOptions: [
        { label: '是', value: true },
        { label: '否', value: false },
      ],
    }
  },
  activated() {
    this.getList();
  },
  created () {
    this.getList();
  },
  computed: {
    ...mapGetters(['permissions'])
  },
  methods: {
    getList() {
      let params = {
        current: this.search.current,
        size: this.search.size,
        name: this.search.name,
      };
      if (this.search.sortField) {
        params.sortField = this.search.sortField;
      } else {
        params.sortField = 'inserted_time';
      }
      if (this.search.sortPolicy) {
        params.sortPolicy = this.search.sortPolicy;
      } else {
        params.sortPolicy = 'desc';
      }

      this.tableLoading = true;
      fetchGoodsTypePage(params).then(response => {
        this.tableData = response.data.data.records;
        this.page.total = response.data.data.total;
        this.tableLoading = false;
      })
    },
    handleAdd() {
      this.$refs.addGoodsTypeFrom.validate((valid) => {
        if (!valid) return
        addGoodsType(this.addGoodsTypeFrom).then(res => {
          this.$message({
            message: '创建成功',
            type: 'success'
          })
          this.addGoodsTypeDialog = false;
          this.getList();
        }).catch(err => {
          this.$message({
            message: err,
            type: 'error'
          })
        })
      })
    },
    handleDelete(row) {
      this.$confirm('确定要删除【' + row.name + '】这个商品分类吗? 分类删除后，该分类下的所有商品将不再使用该分类。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeGoodsTypeById(row.id).then(response => {
          if (response.data.data) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getList();
          }
        }).catch(error => {
          this.$message({
            message: error,
            type: 'error'
          })
        })
      }).catch(function () {
      })
    },
    handleEdit() {
      this.$refs.editGoodsTypeFrom.validate((valid) => {
        if (!valid) return
        this.editGoodsTypeDialog = false;
        editGoodsTypeById(this.editGoodsTypeFrom).then(res => {
          this.$message({
            message: '编辑成功',
            type: 'success'
          })
          this.getList();
        }).catch(err => {
          this.$message({
            message: err,
            type: 'error'
          })
        })
      })
    },
    handleSyncCache() {
      var _this = this;
      _this.$confirm('请确认是否需要同步商品分类缓存？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(function () {
        return syncGoodsTypeCache();
      }).then(() => {
        _this.$message({
          showClose: true,
          message: '同步成功',
          type: 'success',
        });
      }).catch(function (err) {
        if (err == 'cancel') {
          return;
        }
        _this.$message({
          showClose: true,
          message: '同步失败',
          type: 'error',
        });
      });
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.search.current = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.search.size = val;
      this.getList();
    },
    handleSortChange(val) {
      if (val.prop == 'inserted_time') {
        this.search.sortField = 'inserted_time';
      } else {
        this.search.sortField = '';
      }
      if (val.order == 'ascending') {
        this.search.sortPolicy = 'asc';
      } else if (val.order == 'descending') {
        this.search.sortPolicy = 'desc';
      } else {
        this.search.sortPolicy = '';
      }
      this.getList();
    },
    searchReset() {
      this.page.currentPage = 1;
      this.page.pageSize = this.search.size;
      this.search.current = 1;
      this.search.name = '';
      this.getList();
    },
    openEditDialog(row) {
      this.editGoodsTypeFrom.id = row.id;
      this.editGoodsTypeFrom.name = row.name;
      this.editGoodsTypeFrom.isActive = row.isActive;
      this.editGoodsTypeDialog = true;
    },
    openAddDialog() {
      this.addGoodsTypeDialog = true;
    },
    closeAddDialog() {
      this.$refs.addGoodsTypeFrom.resetFields();
      this.addGoodsTypeDialog = false;
    },    
    closeEditDialog() {
      this.$refs.editGoodsTypeFrom.clearValidate();
      this.editGoodsTypeDialog = false;
    },
  }
}
</script>

<style lang="scss" scoped>
.type-list-filter {
  margin: 0 10px;
  /deep/ .el-input__inner {
    border: none;
    font-size: 14px;
  }
  &-value {
    width: 96% !important;
  }
  &-search {
    float: right;
    margin-right: 8px;
  }
  &-reset {
    float: right;
    margin-right: 10px;
    border-color: #5383f3;
    color: #5383f3;
  }
}
.handle-dialog {
  display: flex;
  flex-direction: column;
    &-footer{
      display: flex;
      flex-direction: row;
      padding: 50px 0px;
      &-cancel {
        padding: 8px 12px;
        position: absolute;
        right: 90px;
      }
      &-save {
        padding: 8px 12px;
        position: absolute;
        right: 10px;
        margin-right: 10px;
      }
    }
  }
</style>